// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e249e49e","952":"11872936"}[chunkId] + ".chunk.js";
};